import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./HomeContent.css";
import API_BASE_URL from "../../config/api";

const ReviewSection = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedReviews, setExpandedReviews] = useState({});
  const [slidesToShow, setSlidesToShow] = useState(3);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        setLoading(true);

        console.log("API_BASE_URL:", API_BASE_URL);
        console.log("Request URL:", `${API_BASE_URL}/fetchReviews.php`);

        const response = await fetch(`${API_BASE_URL}/fetchReviews.php`);

        console.log("Status:", response.status);

        const text = await response.text();
        console.log("Response:", text);

        const data = JSON.parse(text);

        /* =========================================================
           ARRANGE REVIEW ORDER
           MY → MY → KR → MY → MY → KR ...
           ========================================================= */

        const myReviews = data.filter(
          (review) => review.country === "MY"
        );

        const krReviews = data.filter(
          (review) => review.country === "KR"
        );

        const otherReviews = data.filter(
          (review) =>
            review.country !== "MY" &&
            review.country !== "KR"
        );

        const arrangedReviews = [];

        let myIndex = 0;
        let krIndex = 0;

        while (
          myIndex < myReviews.length ||
          krIndex < krReviews.length
        ) {
          // MY 1
          if (myIndex < myReviews.length) {
            arrangedReviews.push(myReviews[myIndex]);
            myIndex++;
          }

          // MY 2
          if (myIndex < myReviews.length) {
            arrangedReviews.push(myReviews[myIndex]);
            myIndex++;
          }

          // KR 1
          if (krIndex < krReviews.length) {
            arrangedReviews.push(krReviews[krIndex]);
            krIndex++;
          }
        }

        // If there are reviews from other countries,
        // keep them at the end instead of removing them.
        arrangedReviews.push(...otherReviews);

        setReviews(arrangedReviews);
        setLoading(false);

      } catch (error) {
        console.error("Error fetching reviews:", error);
        setLoading(false);
      }
    };

    fetchReviews();
  }, []);

  // 监听屏幕宽度变化
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width >= 1025) {
        setSlidesToShow(3);
      } else if (width >= 769) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(2);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toggleExpand = (reviewId, e) => {
    e.stopPropagation();

    setExpandedReviews((prev) => ({
      ...prev,
      [reviewId]: !prev[reviewId],
    }));
  };

  const getProductUrl = (productName) => {
    const productMap = {
      Eden: "/bodyfriend-eden",
      "Phantom Rovo": "/bodyfriend-phantom-rovo",
      "Falcon S": "/bodyfriend-falcon-s",
      "Quantum B&O": "/bodyfriend-quantum",
      Familie: "/bodyfriend-familie",
      Carna: "/bodyfriend-carna",
    };

    return productMap[productName] || "/";
  };

  const handleReviewClick = (productName, id) => {
    const url = getProductUrl(productName);
    navigate(url);
  };

  const truncateText = (text, maxLength = 80) => {
    if (!text) return "";

    if (text.length <= maxLength) {
      return text;
    }

    return text.substring(0, maxLength) + "...";
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    arrows: true,
  };

  if (loading) {
    return (
      <section className="review-section">
        <div className="loading-reviews">
          Loading reviews...
        </div>
      </section>
    );
  }

  return (
    <section className="review-section">

      <h2 className="section_title">
        Trusted Reviews from Our Customers
      </h2>

      <p className="section_subtitle">
        Explore real customer experiences with our products.
      </p>

      <div className="review-slider-wrapper">

        <Slider {...settings}>

          {reviews.map((review) => {
            const imageUrl = review.image_url
              ? `${API_BASE_URL}${review.image_url}`
              : null;

            const isExpanded =
              expandedReviews[review.id] || false;

            const description =
              review.description || "";

            const shouldTruncate =
              description.length > 80;

            const displayText = isExpanded
              ? description
              : truncateText(description, 80);

            return (
              <div
                key={review.id}
                className="review-slide-item"
              >

                <div
                  className="review-slide-card"
                  onClick={() =>
                    handleReviewClick(
                      review.product_name,
                      review.id
                    )
                  }
                >

                  <div className="review-image-wrapper">

                    {imageUrl ? (
                      <img
                        className="review-slide-image"
                        src={imageUrl}
                        alt={
                          review.product_name ||
                          "Product"
                        }
                      />
                    ) : (
                      <div className="review-image-placeholder">
                        <span>
                          No Image
                        </span>
                      </div>
                    )}

                  </div>


                  <div className="review-slide-body">

                    <h3 className="review-slide-title">
                      {review.product_name}
                    </h3>


                    <div className="review-text-container">

                      <p className="review-slide-text">
                        {displayText}
                      </p>

                      {shouldTruncate && (
                        <span
                          className="show-more-btn"
                          onClick={(e) =>
                            toggleExpand(
                              review.id,
                              e
                            )
                          }
                        >
                          {isExpanded
                            ? "Show Less"
                            : "Show More"}
                        </span>
                      )}

                    </div>


                    <div className="review-slide-footer">

                      <span className="review-slide-rating">
                        {"★".repeat(
                          review.rating || 5
                        )}
                      </span>


                      <span
                        className={`country-badge ${
                          review.country === "KR"
                            ? "korea"
                            : "malaysia"
                        }`}
                      >
                        {review.country === "KR"
                          ? "South Korea"
                          : "Malaysia"}
                      </span>

                    </div>

                  </div>

                </div>

              </div>
            );
          })}

        </Slider>

      </div>

    </section>
  );
};

export default ReviewSection;